import { motion } from "framer-motion";
import { EASE } from "@/lib/site";

export default function Reveal({ children, delay = 0, y = 40, className = "" }) {
  return (
    <motion.div className={className} initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9, delay, ease: EASE }}>
      {children}
    </motion.div>
  );
}

export const Eyebrow = ({ children, light }) => (
  <div className={`flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] ${light ? "text-[#ff6b70]" : "text-[var(--red)]"}`}>
    <span className="w-8 h-[3px] bg-current -skew-x-[30deg]" />{children}
  </div>
);
